import {
  BasicBlock,
  BasicBlockType,
  RecurringOption,
  RecurringOptionType,
} from "../../types/block/enum";

export const selectRecurringOptionLabel = (
  blockType: BasicBlockType,
  optionValue: RecurringOptionType
) => {
  const blockTypeText = blockType === BasicBlock.TASK ? "task" : "event";

  switch (optionValue) {
    case RecurringOption.THIS:
      return `This ${blockTypeText}`;
    case RecurringOption.THISANDAFTER:
      return `This and following ${blockTypeText}s`;
    case RecurringOption.ALL:
      return `All ${blockTypeText}s`;
    default:
      return "";
  }
};
